// AI Generated Test
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGlobalPolicyComponent } from '@client/app/forms/global-policy/form-global-policy.component';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { PolicyHelperService } from '@client/app/blocks/helpers/policy-helper/policy.helper.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { StateService } from '@uirouter/core';
import { PolicyService } from '@client/app/services/entities/policy/policy.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { PolicyTableService } from '@client/app/modules/policies/services/policy-table.service';
import { GlobalPolicyDialogsTargetsComponent } from '@client/app/pages/global/policy/dialogs/targets/targets.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'global-policy-policies',
    standalone: false,
    template: `
        <page-header
            [icon]="['POLICIES', 'POLICIES'] | monIcons"
            [header]="'Policy List' | translate"
            [subHeader]="getSubHeaderText()">>
            <page-header-content>
                <div class="row">
                    <div class="col-48 text-right">
                        <button class="btn btn-border-radius btn-secondary"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action:'before-policy-create'}"
                                (click)="openPolicyForm()"
                                translate>
                            Add new policy
                        </button>
                        <button *ngIf="showPolicyBotButton" class="btn opt-button opt-button--smaller opt-button-main"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action:'before-policy-create'}"
                                (click)="goToPolicyAIBot()">
                                <span class="fa-lg far fa-sparkles"></span>
                                <span translate>Add Policy with AI</span>
                        </button>
                    </div>
                </div>
            </page-header-content>
        </page-header>

        <mon-tabs [status]="activeTab" [options]="tabs" [maxOptionsDisplay]="5" (onStatus)="onStatus($event)">
            <div class="d-flex align-items-center mb-3">
                <filter-button [showFiltersBtn]="showFilters" [(isFiltersOpen)]="isFiltersOpen"></filter-button>
                <table-search [(model)]="search" class="flex-grow-1" (getPage)="onSearch($event)"></table-search>
            </div>
        </mon-tabs>

        <div class="row">
            <div class="col-48">
                <mon-panel-next>
                    <panel-body panelClass="pb-6 inner-l-smurf inner-r-smurf pt-2">
                        <div class="row" *ngIf="NoPolicies">
                            <div class="col-48 text-center">
                                <img [attr.alt]="'No Policies detected' | translate"
                                     src="/images/policy/no-policies.png"
                                     class="img-responsive center-block" />
                                <p class="pt-3 pb-6 font-size-1-5 font-weight-500" translate>
                                    No content policies have been created yet
                                </p>
                                <button
                                    type="button"
                                    (click)="openPolicyForm()"
                                    class="btn btn-border-radius btn-marine-blue py-3 px-4"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action:'before-policy-create'}"
                                    translate>
                                    Click here to create your first policy
                                </button>
                            </div>
                        </div>
                        <table-container [collection]="policies"
                                         [noResultMessage]="'No policies found' | translate"
                                         (onPageChange)="onPageChange($event)"
                                         (onPerPageChange)="onPageSizeChange($event)"
                                         [progress]="progress"
                                         *ngIf="!NoPolicies">
                            <table-container-top>
                                <div class="mb-4 merge-r-16 merge-l-16 merge-t-16" *ngIf="isFiltersOpen">
                                    <table-filters [(open)]="isFiltersOpen"
                                                   [(ngModel)]="filters"
                                                   name="filters"
                                                   [filters]="availableFilters"
                                                   (onChanges)="onFiltersChanges($event)">
                                    </table-filters>
                                </div>
                            </table-container-top>
                            <table class="table table-hover table-fixed table-with-labels">
                                <thead>
                                    <tr>
                                        <th class="col-3"></th>
                                        <th monTableSort
                                            monSortBy="name"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            class="col-8">
                                            {{ 'Title' | translate }}
                                        </th>
                                        <th monTableSort
                                            monSortBy="first_name"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            class="col-5">
                                            {{ 'Added by' | translate }}
                                        </th>
                                        <th monTableSort
                                            monSortBy="created_at"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            class="col-18">
                                            {{ 'Creation date' | translate }}
                                        </th>
                                        <th monTableSort
                                            monSortBy="matches_count"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            class="col-10 text-right"
                                            colspan="3">
                                            {{ 'Hits across all domains and modules' | translate }}
                                        </th>
                                        <th></th>
                                        <th class="col-5"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let policy of policies; trackBy: trackByPolicyId; let i = index">
                                        <td class="text-v-middle text-center" [attr.aria-label]="'Status' | translate">
                                            <mon-table-policy-type
                                                *ngIf="policy.state !== 'running' && policy.archived_at === null"
                                                class="inline-block"
                                                [passed]="policy.matches_count === 0"
                                                [tooltip]="getTooltipMessage(policy)"
                                                [target]="getPolicyTarget(policy)">
                                            </mon-table-policy-type>
                                            <span *ngIf="policy.state === 'running' && policy.archived_at === null"
                                                  [attr.aria-label]="'Running' | translate">
                                                <span [ngClass]="['GLOBAL', 'POLICIES', 'RUNNING'] | monIcons" class="fa-2x fa-spin">
                                                </span>
                                            </span>
                                            <span class="fa-stack fa-lg text-link"
                                                  [attr.aria-label]="'Archived' | translate"
                                                  [ngbTooltip]="'Archived' | translate"
                                                  placement="top"
                                                  [triggers]="'focus hover'"
                                                  *ngIf="policy.archived_at !== null">
                                                <span [ngClass]="['GLOBAL', 'POLICIES', 'CIRCLE'] | monIcons" class="fa-stack-2x" aria-hidden="true"></span>
                                                <span [ngClass]="['GLOBAL', 'POLICIES', 'ARCHIVED'] | monIcons" class="fa-stack-1x" aria-hidden="true"></span>
                                            </span>
                                        </td>
                                        <td class="text-v-middle">
                                            <policy-information [policy]="policy" class="inline-block">
                                            </policy-information>
                                            <label-table
                                                         [assignedLabels]="policy.labels"
                                                         (getLabels)="getLabels()"
                                                         [existingLabels]="allLabels"
                                                         (onUpdateLabel)="updatePolicy(policy)"
                                                         (click)="$event.stopPropagation()">
                                            </label-table>
                                        </td>
                                        <td class="text-v-middle">
                                            <span *ngIf="policy.created_by">
                                                {{ policy.created_by.first_name }} {{ policy.created_by.last_name }}
                                            </span>
                                        </td>
                                        <td class="text-v-middle">
                                            <span *ngIf="policy.created_at">
                                                {{ policy.created_at | userDate:'ll' }}
                                            </span>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        @let matchesPercentage = { value: 0 };
                                        <td class="text-center text-v-middle cursor-pointer td-content-fill pr-2"
                                            monSetBackgroundColor
                                            (percentage)="matchesPercentage.value = $event"
                                            color="#4384F3"
                                            [count]="policy.matches_count"
                                            [maxCount]="maxCount">
                                            <div [class.text-white]="matchesPercentage.value > 0.4"
                                                 (click)="openTargets(policy)"
                                                 [attr.aria-label]="'Show policy hits per domain' | translate"
                                                 role="button">
                                                {{ policy.matches_count | monNumber }}
                                            </div>
                                        </td>
                                        <td *ngIf="!(policy.state === 'running')"></td>
                                        <td class="text-right text-v-middle"
                                            [attr.aria-label]="'Actions' | translate"
                                            *ngIf="!(policy.state === 'running')">
                                            <mon-action-menu [monActionMenuItems]="policy.dropdown">
                                                <span translate>Action</span>
                                            </mon-action-menu>
                                        </td>
                                        <td class="text-v-middle text-secondary-4 text-right"
                                            *ngIf="policy.state === 'running'"
                                            colspan="2"
                                            translate>
                                            Policy scan in progress
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </table-container>
                    </panel-body>
                </mon-panel-next>
            </div>
        </div>
    `,
})
export class GlobalPolicyPoliciesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    policies: any = [];
    allLabels: any = [];
    selectedCreators: any = [];
    override showLabels: boolean = false;
    showPolicyBotButton: boolean = false;
    override search: string = '';
    override currentSort: any = {
        by: 'matches_count',
        direction: 'desc',
    };
    override activeTab: any = null;
    NoPolicies: boolean = false;
    tabs: any = [];
    showArchivedPolicies: boolean = false;
    progress: any;
    matchCountPercentages: any = [];
    maxCount: number = 0;
    timerPromise: ReturnType<typeof setTimeout> | undefined;
    override showFilters: boolean = false;
    override isFiltersOpen: boolean = false;
    override filters: any = {};
    override availableFilters: any = {};

    constructor (
        private policyRepoService: PolicyRepoService,
        private policyHelperService: PolicyHelperService,
        public override monEventsService: MonEventService,
        private translateService: TranslateService,
        private stateService: StateService,
        private policyService: PolicyService,
        private monModalService: MonModalService,
        private policyTableService: PolicyTableService,
    ) {
        super({ table: true });
        this.getPage = this.getPolicies;
    }

    ngOnInit (): void {
        this.onStatus = this.onStatus.bind(this);
        this.matchCountPercentages = [];
        this.maxCount = 0;
        this.policies = [];
        this.allLabels = [];
        this.selectedCreators = [];
        this.showPolicyBotButton = this.sessionService.customer?.plan_traits?.policy_bot || false;
        this.search = '';
        this.currentSort = {
            by: 'matches_count',
            direction: 'desc',
        };
        this.NoPolicies = false;
        this.tabs = this.policyTableService.getTabs();
        this.activeTab = this.tabs[0].value;
        this.policyTableService.setTab(this.activeTab);
        this.showArchivedPolicies = false;
        this.getPage();
        this.getLabels();
        this.getCreators();
    }

    ngOnDestroy (): void {
        this.timerDestroy();
    }

    timerDestroy (): void {
        if (this.timerPromise !== undefined) {
            clearTimeout(this.timerPromise);
            this.timerPromise = undefined;
        }
    }

    getPolicies (): void {
        const params: any = {
            page_size: this.pageSize,
            page: this.page,
            search: this.search || null,
            mode: this.policyTableService.getTab(),
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            archived: this.policyTableService.getShowArchivedPolicies(),
        };

        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }

        if (this.selectedCreators && this.selectedCreators.length > 0) {
            params['created_by[]'] = this.selectedCreators;
        }

        this.timerDestroy();
        this.progress = this.policyRepoService.getAll(params).then((policies: any) => {
            this.policies = policies;
            this.updateDropdowns();
            this.setMaxCount();
            const runningPolicies = this.policies.filter((policy: any) => {
                return policy.state === 'running';
            }).length;
            this.matchCountPercentages = [];
            if (runningPolicies > 0) {
                this.startAutoReload();
            }
            if (params.mode === null && (params.search === null || params.search === '')) {
                this.NoPolicies = policies.length === 0;
            }
        });

        return this.progress;
    }

    updateDropdowns (): void {
        for (const policy of this.policies) {
            const dropdown = [
                {
                    label: this.translateService.getString('Run policy again'),
                    leftIcon: 'faPlay',
                    action: () => policy.archived_at === null && this.runPolicy(policy),
                    eventParams: { action: 'policy-run', params: { name: policy.name } },
                    disabled: policy.archived_at !== null,
                    shouldShow: policy.state !== 'running' && policy.state !== 'queued',
                },
                {
                    label: this.translateService.getString('Policy in queue'),
                    leftIcon: 'faPlay',
                    disabled: true,
                    shouldShow: policy.state === 'queued',
                },
                {
                    label: this.translateService.getString('Edit'),
                    leftIcon: 'faEdit',
                    action: () => policy.archived_at === null && this.openPolicyForm(policy),
                    eventParams: { action: 'before-policy-edit', params: { name: policy.name } },
                    disabled: policy.archived_at !== null,
                },
                {
                    label: this.translateService.getString('Clone'),
                    leftIcon: 'faClone',
                    action: () => policy.archived_at === null && this.clonePolicy(policy),
                    eventParams: { action: 'before-policy-clone', params: { name: policy.name } },
                    disabled: policy.archived_at !== null,
                },
                {
                    label: this.translateService.getString('Archive'),
                    leftIcon: 'faArchive',
                    action: () => this.archiveOrUnarchivePolicy(policy),
                    eventParams: { action: 'policy-archive', params: { name: policy.name, archiveStatus: policy.archived } },
                    shouldShow: policy.archived_at === null,
                },
                {
                    label: this.translateService.getString('Unarchive'),
                    leftIcon: 'faArchive',
                    action: () => this.archiveOrUnarchivePolicy(policy),
                    eventParams: { action: 'policy-archive', params: { name: policy.name, archiveStatus: policy.archived } },
                    shouldShow: policy.archived_at !== null,
                },
                {
                    label: this.translateService.getString('Delete'),
                    leftIcon: 'faTrashAlt',
                    action: () => this.deletePolicy(policy),
                    eventParams: { action: 'policy-delete', params: { name: policy.name } },
                },
            ];

            policy.dropdown = dropdown.filter((option: any) => option.shouldShow !== false).map((item: any) => {
                return {
                    label: item.label,
                    leftIcon: item.leftIcon,
                    disabled: item.disabled,
                    action: () => {
                        if (item.eventParams) {
                            this.monEventsService.run('actionTrigger', item.eventParams);
                        }

                        if (item.action) {
                            item.action();
                        }
                    },
                };
            });
        }
    }

    override getLabels () {
        return this.labelRepo.getLabels().then((data: any) => {
            this.allLabels = data;
        });
    }

    getCreators (): any {
        const params = {
            page_size: 0,
        };
        return this.policyRepoService.getPolicyAuthors(params).then((authors: any) => {
            const creators = authors.map((author: any) => {
                return {
                    name: author.first_name + ' ' + (author.last_name || ''),
                    value: author.id,
                };
            });
            this.setupFilters(creators);
        });
    }

    setupFilters (creators: any): void {
        this.filters.creators = [];
        if (creators.length) {
            this.availableFilters.creators = creators;
        } else {
            delete this.availableFilters.creators;
        }
    }

    setMaxCount (): void {
        this.maxCount = this.policies.reduce((n: number, policy: any) => {
            return Math.max(n, policy.matches_count);
        }, this.maxCount);
    }

    deletePolicy (policy: any): void {
        this.monModalService
            .confirm(
                this.translateService.getString('Are you sure you want to delete the policy <strong>[[policyName]]</strong>', {
                    policyName: policy.name,
                }),
            )
            .then(() => {
                this.progress = this.policyService.destroy(policy.id).then(() => {
                    this.getPage();
                });
            });
    }

    updatePolicy (policy: any): void {
        const cPolicy: any = {};
        cPolicy.id = policy.id;
        cPolicy.labels = policy.labels.map((label: any) => {
            return label.id;
        });
        this.policyUpdate(cPolicy).then();
    }

    archiveOrUnarchivePolicy (policy: any): void {
        let message = 'Are you sure you want to archive the policy <strong>[[policyName]]</strong>? We will no longer look for matches to this policy. You can always unarchive the policy again later on.';
        if (policy.archived_at !== null) {
            message = 'Are you sure you want to remove the policy <strong>[[policyName]]</strong> from the archive? It will become active again for the next scan.';
        }
        this.monModalService
            .confirm(
                this.translateService.getString(
                    message,
                    {
                        policyName: policy.name,
                    },
                ),
            )
            .then(() => {
                const clone = {
                    id: policy.id,
                    archived: policy.archived_at === null,
                };
                this.progress = this.policyUpdate(clone).then(() => {
                    this.getPage();
                });
            });
    }

    openPolicyForm (policy?: any): void {
        const params = {
            body: FormGlobalPolicyComponent,
            size: 'fw',
            data: {
                policy: policy,
            },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getPage.bind(this) });
    }

    goToPolicyAIBot (): void {
        this.stateService.go('base.customer.global.policy.bot');
    }

    clonePolicy (policy: any): void {
        const params = {
            body: FormGlobalPolicyComponent,
            size: 'fw',
            data: {
                policy: policy.clone(),
            },
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params, callback: this.getPage.bind(this) });
    }

    runPolicy (policy: any): void {
        this.monModalService
            .confirm(
                this.translateService.getString('Are you sure you want to run the policy <strong>[[policyName]]</strong> again?', {
                    policyName: policy.name,
                }),
            )
            .then(() => {
                this.policyService.run(policy.id).then(() => {
                    this.getPage();
                });
            });
    }

    getPolicyTarget (policy: any): any {
        return this.policyHelperService.getType(policy);
    }

    getTooltipMessage (policy: any): any {
        return this.policyHelperService.getTooltipMessageForType(policy);
    }

    startAutoReload (): void {
        this.timerPromise = setTimeout(() => {
            this.getPolicies();
        }, 30000);
    }

    getTooltipForTag (tag: any): any {
        return this.policyHelperService.getTag(tag);
    }

    openTargets (policy: any): void {
        const params = {
            body: GlobalPolicyDialogsTargetsComponent,
            size: 'md',
            data: { policy: policy },
        };
        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    onFiltersChanges (changes: any): void {
        if (!changes) {
            return;
        }
        if (changes.changes) {
            changes = changes.changes;
        }
        if (changes.creators) {
            this.selectedCreators = changes.creators.map((creator: any) => creator.value);
        }
        this.updateFilters(changes);
        this.getPage();
    }

    override onStatus (tab: any): void {
        this.page = 1;
        this.activeTab = tab;
        this.policyTableService.setTab(tab);
        this.getPage();
    }

    trackByPolicyId (index: number, policy: any): any {
        return policy.id;
    }

    getSubHeaderText (): string {
        const foundText = this.translateService.getString('Found');
        const policyText = this.translateService.getString('policy');
        const policiesText = this.translateService.getString('policies');
        const plural = this.policies.total === 1 ? policyText : policiesText;
        return `${foundText} ${this.policies.total} ${plural}`;
    }

    // PROTECTED
    policyUpdate (policy: any): any {
        return this.policyService.update(policy);
    }

    // Properties from BaseLabelsController
    override selectedLabels: any;
    override updateFilters: any;
}
